import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { Login } from './pages/Login';
import { Intake } from './pages/Intake';
import { Dashboard } from './pages/Dashboard';
import { Students } from './pages/Students';
import { StudentDetail } from './pages/StudentDetail';
import { PlanDetail } from './pages/PlanDetail';
import { Exercises } from './pages/Exercises';
import { Comments } from './pages/Comments';
import { Profile } from './pages/Profile';
import { Calculators } from './pages/Calculators';

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/intake/:token" element={<Intake />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="students" element={<Students />} />
        <Route path="students/:id" element={<StudentDetail />} />
        <Route path="plans/:id" element={<PlanDetail />} />
        <Route path="exercises" element={<Exercises />} />
        <Route path="comments" element={<Comments />} />
        <Route path="calculators" element={<Calculators />} />
        <Route path="profile" element={<Profile />} />
      </Route>

      {/* Unauthorized */}
      <Route
        path="/unauthorized"
        element={
          <div className="min-h-screen flex items-center justify-center">
            <div className="card text-center">
              <h1 className="text-2xl font-bold text-dark-100 mb-2">Acceso Denegado</h1>
              <p className="text-dark-400">No tenés permisos para acceder a esta página.</p>
            </div>
          </div>
        }
      />
    </Routes>
  );
}

export default App;
